import { render, staticRenderFns } from "./RequestsView.vue?vue&type=template&id=32e2a020&"
import script from "./RequestsView.vue?vue&type=script&lang=ts&"
export * from "./RequestsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports